import React, { useEffect, useState } from "react";
import "../../../src/styles/Components/Write/WriteBoard.css";
import {
  NoticeApi,
  NoticeAttachmentApi,
  ErrorHandler,
} from "../../system/ApiService";
import { Link, useHistory } from "react-router-dom";
import { useUserState } from "../../system/context/UserContext";
import axios from "axios";

// syncfusion
import { enableRipple } from "@syncfusion/ej2-base";
import { ButtonComponent } from "@syncfusion/ej2-react-buttons";
import { MultiSelectComponent } from "@syncfusion/ej2-react-dropdowns";
import { MessageComponent } from "@syncfusion/ej2-react-notifications";

// material ui
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {
  CustomButtonBlackSpace,
  CustomButtonBlue,
  CustomButtonGreen,
  CustomButtonGrey,
  CustomButtonRed,
} from "../../styles/Common/CommonComponent";
import NoticeComponent from "../Common/NoticeComponent";
import HtmlContent from "../Common/HtmlContext";
import AlertModal from "../Common/AlertModal";
import { Grid } from "@mui/material";
import { CustomText } from "../../styles/Components/Portlet/CustomText";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 700,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

function NoticeDetailBoard(props: any) {
  let history = useHistory();
  const id = props.data.noticeId;
  const user = useUserState();

  const [loading, setLoading] = useState(false);
  useEffect(() => {
    return () => setLoading(false);
  }, []);

  // 버튼
  enableRipple(true);

  //// 글 삭제
  const NoticeDelete = () => {
    if (window.confirm("공지사항을 삭제하시겠습니까?")) {
      NoticeApi.DeleteNotice(props.data.noticeId)
        .then(() => {
          AlertModal("success", "공지사항이 삭제되었습니다.");
          history.push("/notice/board/1");
        })
        .catch((error) => {
          let msg = ErrorHandler(error);
          AlertModal("msg", msg);
        });
    }
  };
  const [uploadData, setUploadData] = useState([]);
  // 첨부 파일 정보
  useEffect(() => {
    if (props.data.fileuploadFolder) {
      NoticeAttachmentApi.GetNoticeAttachmentList(props.data.fileuploadFolder)
        .then((res) => {
          setUploadData(res.data);
        })
        .catch((error) => {
          let msg = ErrorHandler(error);
          AlertModal("msg", msg);
        });
    }
  }, [props]);

  function downloadfile(item: any) {
    window.location.assign(
      `https://inbodyinfra.blob.core.windows.net/inbodyportal/Notice/${item.fileuploadFolder}/${item.noticeAttachmentFileName}`
    );
  }

  // 메일 보내기
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const sendNotice = () => {
    if (mailsendList.length === 0) {
      AlertModal("check", "메일 받을 대상을 선택해주세요.");
      return;
    }

    let sendDepartment = [{ emailAddress: { address: `${mailsendList[0]}` } }];

    for (let i = 1; i < mailsendList.length; i++) {
      sendDepartment.push({ emailAddress: { address: `${mailsendList[i]}` } });
    }
    let token = sessionStorage.getItem("token") || "";

    fetch("https://graph.microsoft.com/v1.0/me/sendMail", {
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
      },
      method: "POST",
      body: JSON.stringify({
        message: {
          subject: props.data.noticeTitle,
          body: {
            contentType: "HTML",
            content: props.data.noticeContent,
          },
          toRecipients: sendDepartment,
        },
      }),
    }).then(() => setOpen(false));
  };

  // multiSelect
  const [multiSelectData, setMultiSelectData]: any = useState([]);
  const fields = { value: "email", text: "name" };
  const [mailsendList, setMailSendList] = useState([]);

  useEffect(() => {
    axios
      .get("https://360degree.weareinbody.com/api/employee/email")
      .then((res) => {
        setMultiSelectData(res.data);
      });
  }, []);

  function itemTemplate(data: any): JSX.Element {
    return (
      <span>
        <span>{data.name}</span>
        <span style={{ right: "15px", position: "absolute" }}>
          {data.email}
        </span>
      </span>
    );
  }

  function multiselctemployee(args: any) {
    setMailSendList(args.nativeEvent.text);
  }

  return (
    <>
      {props.data ? (
        <div
          className={
            user.teamName === props.data.teamName ? "boardTeam" : "board"
          }
        >
          {user.teamName === props.data.teamName ? (
            <MessageComponent
              style={{ marginBottom: "13px" }}
              id="msg_default"
              content="작성자와 같은 부서이신 분들은 해당 글의 메일 보내기, 수정, 삭제 기능을 이용하실 수 있습니다. "
            ></MessageComponent>
          ) : (
            ""
          )}

          <div className="board_write">
            <div className="title">
              <Grid container alignItems="center" mb="10px">
                <Grid item mr="45px">
                  <CustomText type="title">제목</CustomText>
                </Grid>
                <Grid item mr="10px">
                  <NoticeComponent type={props.data.type} />
                </Grid>
                <Grid>
                  <CustomText type="subtitle2">
                    {props.data.noticeTitle}
                  </CustomText>
                </Grid>
              </Grid>
            </div>
            <div className="notice_info">
              <Grid container alignItems="center" mb="10px">
                <Grid container item xs={12} sm={6} alignItems="center">
                  <Grid item mr="25px">
                    <CustomText type="title">작성자</CustomText>
                  </Grid>
                  <Grid item>
                    <CustomText type="subtitle2">
                      {props.data.noticeWriter}
                    </CustomText>
                  </Grid>
                </Grid>

                {props.data.noticeCreatedAt === props.data.noticeModifiedAt ? (
                  <Grid container item xs={12} sm={6} alignItems="center">
                    <Grid item mr="25px">
                      <CustomText type="title">작성일</CustomText>
                    </Grid>
                    <Grid item>
                      <CustomText type="subtitle2">
                        {props.data.noticeCreatedAt}
                      </CustomText>
                    </Grid>
                  </Grid>
                ) : (
                  <Grid container item xs={12} sm={6} alignItems="center">
                    <Grid item mr="25px">
                      <CustomText type="title">수정일</CustomText>
                    </Grid>
                    <Grid>
                      <CustomText type="subtitle2">
                        {props.data.noticeModifiedAt}
                      </CustomText>
                    </Grid>
                  </Grid>
                )}
              </Grid>
            </div>
            <div className="cont">
              <Grid container alignItems="center" mb="15px">
                <Grid item xs={12}>
                  <CustomText type="title">내용</CustomText>
                </Grid>
                <Grid item xs={12} mt="15px">
                  <HtmlContent
                    data={
                      props.data.noticeContent
                        ? props.data.noticeContent
                        : "작성된 내용이 없습니다."
                    }
                  ></HtmlContent>
                </Grid>
              </Grid>
            </div>
            <div className="info">
              <div className="fileuploadbox">첨부파일</div>
              <div className="filebox">
                {uploadData.map((item: any) => (
                  <li key={`${item.noticeAttachmentFileName}`}>
                    {item.noticeAttachmentFileName}
                    <ButtonComponent
                      iconCss="e-icons e-download"
                      className="fileuploadButton"
                      onClick={() => downloadfile(item)}
                    >
                      다운로드
                    </ButtonComponent>
                  </li>
                ))}
              </div>
            </div>
          </div>

          {user.teamName === props.data.teamName ||
          user.parentTeam === props.data.teamName ||
          (user?.group && user.group === props.data.teamName) ? (
            <div className="bt_wrap">
              <span>
                <CustomButtonBlue
                  onClick={handleOpen}
                  style={{ margin: "10px" }}
                >
                  메일 보내기
                </CustomButtonBlue>
              </span>
              <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                disableScrollLock
              >
                <Box sx={style}>
                  <Typography
                    id="modal-modal-title"
                    variant="h6"
                    component="h2"
                    style={{ marginBottom: "30px" }}
                  >
                    전사 공지 메일 발송
                  </Typography>

                  <Typography
                    variant="subtitle1"
                    style={{ marginBottom: "5px" }}
                  >
                    메일 받는 사람을 선택해주세요.
                  </Typography>

                  <MultiSelectComponent
                    id="sendemail"
                    dataSource={multiSelectData}
                    fields={fields}
                    mode="Box"
                    placeholder="ex. 본사_2022    "
                    itemTemplate={itemTemplate}
                    onChange={multiselctemployee}
                  />
                  <div style={{ marginTop: "30px", textAlign: "right" }}>
                    <CustomButtonGrey onClick={handleClose}>
                      취소
                    </CustomButtonGrey>
                    <CustomButtonBlackSpace onClick={sendNotice}>
                      메일 보내기
                    </CustomButtonBlackSpace>
                  </div>
                </Box>
              </Modal>

              <span>
                <CustomButtonGreen
                  style={{ margin: "5px" }}
                  onClick={() => {
                    history.push({
                      pathname: `/notice/edit/${id}`,
                      state: id,
                    });
                  }}
                >
                  수정
                </CustomButtonGreen>
              </span>
              <span>
                <CustomButtonRed
                  onClick={NoticeDelete}
                  style={{ margin: "10px" }}
                >
                  삭제
                </CustomButtonRed>
              </span>
              <span>
                <Link to="/notice/board/1" style={{ margin: "5px" }}>
                  <CustomButtonGrey>목록</CustomButtonGrey>
                </Link>
              </span>
            </div>
          ) : (
            <div className="bt_wrap">
              <span>
                <Link to="/notice/board/1" style={{ margin: "5px" }}>
                  <CustomButtonGrey>목록</CustomButtonGrey>
                </Link>
              </span>
            </div>
          )}
        </div>
      ) : (
        ""
      )}
    </>
  );
}

export default NoticeDetailBoard;
